// extracted by mini-css-extract-plugin
export default {"btn":"Navlink_btn__PPvQ2"};